//AZIENDE
    export const COMPANY_GET_LIST           = "ListaAziende";
    export const COMPANY_GET_LIST_TUPLE     = "ListaAziendeTupla";
    export const COMPANY_ADD_MODIFY         = "AggiungiModificaAzienda";
//BILANCE
    export const LIBRA_GET_LIST             = "ListaBilance";
    export const LIBRA_ADD_MODIFY           = "AggiungiModificaBilancia";
    export const LIBRA_GET_TIPOLOGY_LIST    = "ListaTipologieBilance";
    export const LIBRA_GET_MODEL_LIST       = "ListaModelliBilance";
//CAMPI
    export const FIELD_GET_LIST             = "CampiPersonalizzati";
    export const FIELD_ADD_MODIFY           = "CampoPersonalizzato";
//HOLDING
    export const HOLDING_GET_LIST           = "HoldingList";
    export const HOLDING_ADD_MODIFY         = "AggiungiModificaHolding";
//OPERATORI
    export const USER_GET_INFO              = "Account/UserInfo";
    export const USER_GET_LIST              = "Operatori";
    export const USER_REGISTER              = "Account/Register";
//IMPIANTI
    export const PLANT_GET_LIST             = "ListaImpianti";
    export const PLANT_GET_LIST_TUPLE       = "ListaImpiantiTupla";
    export const PLANT_ADD_MODIFY           = "AggiungiModificaImpianto";
//PESATE
    export const WEIGHING_GET_LIST          = "ListaPesateFiltrata";
    export const WEIGHING_GET_DETAILS       = "PesataDettaglio";
//STAMPANTI
    export const PRINTER_GET_LIST           = "ListaStampanti";
    export const PRINTER_ADD_MODIFY         = "AggiungiModificaStampante";
    export const PRINTER_GET_MODEL_LIST     = "ListaModelliStampanti";
    export const PRINTER_GET_BRAND_LIST     = "ListaMarcheStampanti";
//STAMPE
    export const PRINT_GET_LIST             = "ListaStampe";
    export const PRINT_FAVORITE_ADD_MODIFY  = "AggiungiModificaStampaPreferita";
    export const PRINT_DEFAULT_ADD_MODIFY   = "AggiungiModificaStampaPredefinita";
//TABELLE
    export const TABLE_GET_LIST             = "TabellePersonalizzate";
    export const TABLE_ADD_MODIFY           = "TabellaPersonalizzata";
    export const TABLE_GET_VALUES           = "ValoriTabellaLista";
    export const TABLE_ADD_MODIFY_VALUE     = "AggiungiListaValoriTabella";
//IMPOSTAZINI
    export const CHANGE_PASSWORD            = "Account/ChangePassword";
//FILTRI
           const FILTER = "Filtri/";
    export const FILTER_LOGICAL_OPERATOR    = FILTER + "OperatoriLogici" 
    
    export const WEIGHING_SET_FILTER        = FILTER + "SetPesate";
    export const WEIGHING_GET_FILTER        = FILTER + "GetPesate";
//LINGUA
    const LANGUAGE = "Language/";
    export const LANGUAGE_SET               = LANGUAGE + "Set";
    export const LANGUAGE_GET               = LANGUAGE + "List";
//ESPORTAZIoNI
    const EXPORT = "Export/";
    export const EXPORT_FORMAT_LIST         = EXPORT + "FormatList";
    export const EXPORT_PESATE              = EXPORT + "Pesate";


// WEBPACK FOOTER //
// ./src/Utils/Strings/Service_Endpoint.js